import { css } from '@emotion/css';

export const styTitleCenter = css`
  display: flex;
  justify-content: center;
  flex-flow: column wrap;
`;

export const styTimeline = css`
  display: flex;
  justify-content: space-between;
  margin: 24px 0;
`;

export const styAmountEligible = css`
  font-weight: bold;
  font-size: 20px;
`;

export const styTimelineLeft = css`
  text-align: left;
  margin-top: 16px;

  div:nth-child(1) > div > div:nth-child(1) {
    background: #3a83f9 !important;
    color: white !important;
  }

  div:nth-last-child(1) > div {
    ::after {
      display: none;
    }
  }
`;

export const styDateTitle = css`
  margin-left: 22px;
`;

export const styTagTimeline = css`
  display: flex;
  flex-flow: row;
  align-items: center;
`;

export const styDateContent = css`
  margin-left: 8px;
`;

export const styVerticalLine = css`
  margin-bottom: 4px;
  width: 65%;
  height: 16px;
  position: relative;
  text-align: center;

  ::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 23%;
    border-left: 2px solid #c4dafd;
    transform: translate(-50%);
  }
`;

export const styTagWrapper = css`
  background: #c4dafd !important;
  color: #4b6a81 !important;
  font-size: 10px !important;
  cursor: inherit !important;
`;

export const styAmountRight = css`
  text-align: right;
  margin-top: 16px;
  display: flex;
  flex-flow: column wrap;
`;

export const styAmountContent = css`
  font-weight: bold;
  margin-top: 32px;

  :nth-child(1) {
    margin: 0;
  }
`;

export const styInfoContent = css`
  text-align: left;
`;

export const styTextContent = css`
  display: block;
  width: 100%;

  :nth-child(2) {
    margin: 16px 0;
  }
`;
